<div class="vh-100 d-flex align-items-center justify-content-center" *ngIf="!authToken">
    <div>
        <div><loader-lite [customClass]="'h-auto'"></loader-lite></div>
        <h1 class="text-center mt-4">{{count}}</h1>
        <span>Please wait, you're being redirected...</span>
    </div>
</div>
